var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 13L11.4 17L17.8 8.99999M12.2 24.2C10.7292 24.2 9.27279 23.9103 7.91395 23.3474C6.5551 22.7846 5.32042 21.9596 4.2804 20.9196C3.24039 19.8796 2.4154 18.6449 1.85255 17.286C1.2897 15.9272 1 14.4708 1 13C1 11.5292 1.2897 10.0728 1.85255 8.71393C2.4154 7.35509 3.24039 6.12041 4.2804 5.08039C5.32042 4.04038 6.5551 3.21539 7.91395 2.65254C9.27279 2.08968 10.7292 1.79999 12.2 1.79999C15.1704 1.79999 18.0192 2.97998 20.1196 5.08039C22.22 7.1808 23.4 10.0296 23.4 13C23.4 15.9704 22.22 18.8192 20.1196 20.9196C18.0192 23.02 15.1704 24.2 12.2 24.2Z",
    stroke: "#319F43",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.eb51128b3f0e837ec193f17ea06844f1.svg";
export { ForwardRef as ReactComponent };